import firebase from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

  apiKey: "AIzaSyB25o2Gssfdkk5VPsQ-ua0mEeW_r0ip8qM",
  authDomain: "prueba2-785d3.firebaseapp.com",
  projectId: "prueba2-785d3",
  storageBucket: "prueba2-785d3.firebasestorage.app",
  messagingSenderId: "124286022704",
  appId: "1:124286022704:web:f4ef1f71f736bfd79629f5",
  measurementId: "G-8E9W18XFNS"

  
  // apiKey: "AIzaSyD0emcKQQUbLtKVUewgHTjVhNjgo_M0Vt8",
  // authDomain: "modulosmialcaldia-2219f.firebaseapp.com",
  // projectId: "modulosmialcaldia-2219f",
  // storageBucket: "modulosmialcaldia-2219f.firebasestorage.app",
  // messagingSenderId: "316986650985",
  // appId: "1:316986650985:web:1df74abcc8ea00ed86cdf8",
  // measurementId: "G-9Q72F3HDMY"
  
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig, "store-backup");
const firebaseBackup = firebase.firestore();
export { firebaseBackup, firebase };